import React, { useState } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  IconButton,
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  Typography
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

const UnmatchedMoviesDialog = ({ openViewUnMachedDialog, onClose, unmatchedMovies }) => {
  console.log("unmatchedMovies : ",unmatchedMovies)
  return (
    <Dialog open={openViewUnMachedDialog} onClose={onClose} fullWidth maxWidth="md">
      <DialogTitle sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
      <Typography variant="h6" component="span">UnMatched</Typography>
        <IconButton onClick={onClose}>
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent>
        <Table>
          <TableHead style={{ position: 'sticky', top: 0, backgroundColor: 'black', color: 'white', zIndex: 1 }}>
            <TableRow>
              <TableCell style={{color: 'white'}}><b>Title</b></TableCell>
              <TableCell style={{color: 'white'}}><b>Year</b></TableCell>
              <TableCell style={{color: 'white'}}><b>{unmatchedMovies?.[0]?.item ? "Albums" : "Type"}</b></TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {unmatchedMovies.length > 0 ? (
              unmatchedMovies.map((movie, index) => (
                <TableRow key={index}>
                  <TableCell>{movie?.Title || movie?.item?.Artist || movie?.CSV?.Artist}</TableCell>
                  <TableCell>{movie?.Year || movie?.item?.Years || movie?.CSV?.Years}</TableCell>
                  <TableCell>{movie?.Type || movie?.item?.Albums || movie?.CSV?.Albums}</TableCell>
                </TableRow>
              ))
            ) : (
              <TableRow>
                <TableCell colSpan={3} align="center">No unmatched movies</TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </DialogContent>
    </Dialog>
  );
};

export default UnmatchedMoviesDialog;
